import $ from 'jquery';

function init({ selector = '.js-c-tab-sidenav'} = {}) {
    const mobileMediaQuery = window.matchMedia('(min-width: 1024px)'); // match css scss variable MD

    // init - set min height to container
    if (mobileMediaQuery.matches) {

        $(selector).each(function() {
            $(this).css({
                minHeight: $(this).find('.c-accordion-item-content.show').height()
            });
        });
    }

    // if target is shown and target is clicked - stay visible
    // set Aria on elements
    // only add custom toggle for MD size viewport
    $(selector).on('hide.bs.collapse', (e) => {
        if (mobileMediaQuery.matches) {
            if ($(e.target).hasClass('show')) {
                $(e.currentTarget).find('.c-accordion-item-content').removeClass('show');
                $(e.target).addClass('show');
                return false;
            }
        }
        return true;
    });

    // if other elements are clicked - set and remove css classes for active and none active state.
    // set Aria on elements
    // only add custom toggle for MD size viewport
    $(selector).on('show.bs.collapse', (e) => {
        if (mobileMediaQuery.matches) {
            $(e.currentTarget).find('.c-accordion-item-header').addClass('collapsed');
            $(e.currentTarget).find('.c-accordion-item-content').removeClass('show');
            $(e.target).addClass('show');

            // set contens height as min-height to container - absolute elements, parent dont get height
            $(e.currentTarget).css({
                minHeight: $(e.target).height()
            });

            // set Aria
            $(e.currentTarget).find('.c-accordion-item-header').attr('aria-expanded', false);
        }
    });
}

export default {
    init
};
